<project-navigation
  [headerTitle]="'projectNavigation.title_compare_item_lists'"
  [headerText]="'projectNavigation.text_compare_item_lists'"
  [model]="model"
  [submitEnabled]="submitEnabled"
  [headerHelpLink]="'helplink.compareitemlist'"
  [actionButtonLabel]="'global.label.next'"
  [visibleFeatures]="{
    compositeCheckBox: false,
    pinnedProjects: true,
    recentlyUsedProjects: true,
    history: false,
    projectActionsMenu: false,
    projectGroupContextMenu: false,
    newConfigurationGroupBtn: false,
    newFolderBtn: false,
    dialogSearch: true,
    tabs: true,
    breadcrumbs: true,
  }"
  (submitEnabledChanged)="updateSubmitEnabled()"
  (actionBtnClick)="compareItemList()"
  (submitSelectedConfiguration)="compareItemList()"
  (cancel)="cancel()"
></project-navigation>
